import React, { memo, useRef } from "react";
import { Row, Image } from "react-bootstrap";
import { useDrag, useDrop } from "react-dnd";

function DrogDropItem(props) {
  return (
    <Row className="m-0">
      {props.value.map((item) => (
        <DragItem key={item.id} id={item.id} onMoveItem={props.moveItem}>
          {props.displayTable ? (
            <GridItem className="col-md-4 pt-4 enTableBox d-flex align-items-center justify-content-center">
              <div className="enPositionTopLeft">
                <div className="f10-400">
                  <b>Location: </b>
                  {item.location}
                </div>
                <div className="f10-400">
                  <b>T-Number: </b>
                  {item.seat_number}
                </div>
              </div>
              <Image
                src={item.src}
                alt="Rectangle"
                title="Rectangle"
                className="tableShape"
              />
            </GridItem>
          ) : (
            <GridItem>
              <div
                className={`enSeat ${
                  item.status === "AVAILABLE"
                    ? "available"
                    : item.status === "DIRTY"
                    ? "dirty"
                    : item.status === "OCCUPIED"
                    ? "occupied"
                    : item.status === "ONHOLD"
                    ? "onhold"
                    : item.status === "UNAVAILABLE"
                    ? "unavailable"
                    : null
                }`}
              >
                {item.seatNo}
                {item.seat_number}
              </div>
            </GridItem>
          )}
        </DragItem>
      ))}
    </Row>
  );
}

export default DrogDropItem;
export const GridItem = ({ forwardedRef, ...props }) => (
  <div ref={forwardedRef} {...props} />
);

export const DragItem = memo(({ id, onMoveItem, children }) => {
  const ref = useRef(null);

  const [{ isDragging }, connectDrag] = useDrag({
    item: { id, type: "IMG" },
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging(),
      };
    },
  });

  const [, connectDrop] = useDrop({
    accept: "IMG",
    hover(hoveredOverItem) {
      if (hoveredOverItem.id !== id) {
        onMoveItem(hoveredOverItem.id, id);
      }
    },
  });

  connectDrag(ref);
  connectDrop(ref);

  const opacity = isDragging ? 0.5 : 1;
  const containerStyle = { opacity };

  return React.Children.map(children, (child) =>
    React.cloneElement(child, {
      forwardedRef: ref,
      style: containerStyle,
    })
  );
});
